/**
 * @typedef {Object} Queue
 * @property {number} id
 * @property {number} timeout
 * @property {string|null} musiconhold
 * @property {number} wrapuptime
 * @property {boolean} autopause
 * @property {boolean} ringinuse
 * @property {string} strategy
 * @property {string} name
 * @property {string|null} periodic_announce
 * @property {number} periodic_announce_frequency
 * @property {boolean} fila_personalizada
 * @property {string|null} foraHorario
 * @property {boolean} disable
 * @property {number|null} announceFrequency
 * @property {number|null} announcePosition
 * @property {string} closing_message
 * @property {boolean} closing_message_enabled
 * @property {string} greeting_message
 * @property {boolean} greeting_message_enabled
 * @property {string} transfer_message
 * @property {boolean} transfer_message_enabled
 * @property {boolean} send_attendant_name
 * @property {string} strategy_chat
 * @property {number} max_chat_per_user
 * @property {string|null} chat_overflow
 * @property {string|null} queue_of_chat_overflow
 * @property {string} message_of_chat_overflow
 * @property {boolean} active_chat_in_chat_distribution
 * @property {number} scheduleTime_id
 * @property {number} centrodecustoId
 * @property {number|null} callback_id
 * @property {string} color
 * @property {boolean} is_chat
 * @property {boolean} is_telephony
 * @property {number} levelOfService
 * @property {Object} centrodecusto
 * @property {number} centrodecusto.id
 * @property {string} centrodecusto.name
 * @property {string} centrodecusto.description
 */

/**
 * @type {{
 *  loggedPhoneQueues: Queue[]
 * }}
 */
const INITIAL_STATE = {
  loggedPhoneQueues: [],
};

/**
 * Esse reducer acompanha em tempo real as filas, de chat e de telefonia.
 */
export default function queuesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@UPDATE_LOGGED_PHONE_QUEUES':
      return {
        ...state,
        loggedPhoneQueues: action.payload
      };
    default:
      return state;
  }
}
